/**
 * The reminder inputs shared by the assignment composer, the work order's
 * Påminnelser row and Inställningar › Aviseringar: an optional on/off box and
 * two day counts, where an empty count means that reminder is off.
 */
import React from 'react';
import { Form } from 'react-bootstrap';
import { DAYS_BEFORE_MAX, REPEAT_EVERY_DAYS_MAX, ReminderDraft } from '../../types/workOrderReminders';

interface ReminderFieldsProps {
    draft: ReminderDraft;
    onChange: (draft: ReminderDraft) => void;
    /** Unique per page, for the input ids */
    idPrefix: string;
    disabled?: boolean;
    /** Show the "Skicka påminnelser" box (not on the instance default) */
    toggle?: boolean;
}

const ReminderFields: React.FC<ReminderFieldsProps> = ({ draft, onChange, idPrefix, disabled, toggle = true }) => {
    const fieldsDisabled = disabled || (toggle && !draft.enabled);
    return (
        <div className="reminder-fields">
            {toggle && (
                <Form.Check
                    type="checkbox"
                    id={`${idPrefix}-enabled`}
                    label="Skicka påminnelser till externa mottagare"
                    checked={draft.enabled}
                    disabled={disabled}
                    onChange={(e) => onChange({ ...draft, enabled: e.target.checked })}
                    className="mb-2"
                />
            )}
            <div className="reminder-fields__row">
                <Form.Group controlId={`${idPrefix}-before`}>
                    <Form.Label className="small mb-1">Dagar före förfallodatum</Form.Label>
                    <Form.Control
                        type="number"
                        inputMode="numeric"
                        min={0}
                        max={DAYS_BEFORE_MAX}
                        size="sm"
                        placeholder="Ingen"
                        value={draft.daysBefore}
                        disabled={fieldsDisabled}
                        onChange={(e) => onChange({ ...draft, daysBefore: e.target.value })}
                    />
                </Form.Group>
                <Form.Group controlId={`${idPrefix}-repeat`}>
                    <Form.Label className="small mb-1">Vid försening, upprepa var N:e dag</Form.Label>
                    <Form.Control
                        type="number"
                        inputMode="numeric"
                        min={1}
                        max={REPEAT_EVERY_DAYS_MAX}
                        size="sm"
                        placeholder="Bara dagen efter"
                        value={draft.repeatEveryDays}
                        disabled={fieldsDisabled}
                        onChange={(e) => onChange({ ...draft, repeatEveryDays: e.target.value })}
                    />
                </Form.Group>
            </div>
            <Form.Text className="text-muted">
                Tomt fält = ingen påminnelse före, respektive bara en påminnelse dagen efter förfallodatum.
                Den som delegerade får också ett mejl dagen efter.
            </Form.Text>
        </div>
    );
};

export default ReminderFields;
